import React, { useState } from 'react';
import { 
  MousePointer2, 
  Hand, 
  ZoomIn,
  Type, 
  Square, 
  Circle,
  Image,
  PenTool,
  Minus,
  Triangle,
  Star,
  Palette,
  Sparkles,
  RotateCw,
  Diamond,
  Zap,
  Bot,
  Cpu,
  Wand2
} from 'lucide-react';

const LeftToolbar = ({ selectedTool, onToolSelect }) => {

  const tools = [
    { id: 'select', icon: MousePointer2, label: 'Select Tool', shortcut: 'V' },
    { id: 'hand', icon: Hand, label: 'Hand Tool', shortcut: 'H' },
    { id: 'zoom', icon: ZoomIn, label: 'Zoom Tool', shortcut: 'Z' },
    { id: 'divider1' },
    { id: 'text', icon: Type, label: 'Text Tool', shortcut: 'T' },
    { id: 'divider2' },
    { id: 'rectangle', icon: Square, label: 'Rectangle Tool', shortcut: 'R' },
    { id: 'ellipse', icon: Circle, label: 'Ellipse Tool', shortcut: 'E' },
    { id: 'image', icon: Image, label: 'Image Tool', shortcut: 'I' },
    { id: 'divider3' },
    { id: 'pen', icon: PenTool, label: 'Pen Tool', shortcut: 'P' },
    { id: 'line', icon: Minus, label: 'Line Tool', shortcut: 'L' }
  ];

  const aiTools = [
    { id: 'ai-icon-1', type: 'image', src: '/images/ai-icon-1.png', selectedSrc: '/images/ai-icon-1-selected.png', label: 'Claude 4 Sonnet' },
    { id: 'ai-icon-2', type: 'image', src: '/images/ai-icon-2.png', selectedSrc: '/images/ai-icon-2-selected.png', label: 'ChatGPT5' },
    { id: 'ai-icon-3', type: 'image', src: '/images/ai-icon-3.png', selectedSrc: '/images/ai-icon-3-selected.png', label: 'Grok 4' },
    { id: 'ai-icon-4', type: 'image', src: '/images/ai-icon-4.png', selectedSrc: '/images/ai-icon-4-selected.png', label: 'Gemini 2.5' }
  ];

  const handleToolClick = (toolId) => {
    if (toolId.startsWith('divider')) return;
    onToolSelect(toolId);
    console.log(`Selected tool: ${toolId}`);
  };

  const renderTool = (tool) => {
    if (tool.id.startsWith('divider')) {
      return (
        <div key={tool.id} className="w-full h-px bg-gray-600 my-1" />
      );
    }

    const isSelected = selectedTool === tool.id;

    return (
      <button
        key={tool.id}
        onClick={() => handleToolClick(tool.id)}
        className={`w-8 h-8 flex items-center justify-center rounded transition-all duration-200 ${
          isSelected 
            ? 'bg-white text-black shadow-sm' 
            : 'text-gray-300 hover:bg-gray-600 hover:text-white'
        }`}
        title={`${tool.label}${tool.shortcut ? ` (${tool.shortcut})` : ''}`}
        style={{
          backgroundColor: isSelected ? '#ffffff' : 'transparent'
        }}
      >
        {tool.type === 'image' ? (
          <img 
            src={isSelected && tool.selectedSrc ? tool.selectedSrc : tool.src} 
            alt={tool.label}
            className="w-8 h-8 object-contain"
            style={{
              filter: isSelected ? 'none' : 'brightness(0) invert(1)'
            }}
          />
        ) : (
          <tool.icon size={18} />
        )}
      </button>
    );
  };

  return (
    <div 
      className="flex flex-col items-center py-3 px-2 h-full"
      style={{ 
        backgroundColor: '#424241',
        width: '48px'
      }}
    >
      {/* Tools */}
      <div className="flex flex-col items-center gap-1">
        {tools.map(renderTool)}
      </div>

      {/* Spacer to push bottom tools down */}
      <div className="flex-1" />

      {/* Bottom section - AI tools */}
      <div className="flex flex-col items-center gap-2 mt-4">
        {aiTools.map(renderTool)}
      </div>
    </div>
  );
};

export default LeftToolbar;